import { useEffect, useState } from "react";
import './Management.css';
import './Management3.css';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // ✅ Import autoTable
import axios from "axios";
import { useLoader } from "../../../../context/LoaderProvider";

const LeadsOrders = () => {
    const [showDetails, setShowDetails] = useState({});
    const [paymentSuccessData, setPaymentSuccessData] = useState({});
    const isMobile = window.innerWidth < 768;
    const { showLoader, hideLoader } = useLoader();

    const handlePayment = async (order) => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("⚠️ Vendor ID or auth token missing.");
            return;
        }

        const amount = Number(order.leadPrice || 0);
        const amountInPaise = Math.round(amount);
        const leadId = order.orderId;
        const orderIdNum = Number(order.orderId);
        const vendorIdNum = Number(vendorId);

        if (!leadId || !vendorIdNum || !amount || !orderIdNum) {
            console.error("❌ Invalid payment parameters:", { leadId, vendorIdNum, amount, orderIdNum });
            alert("⚠️ Payment cannot be processed due to missing data.");
            return;
        }

        // Load Razorpay SDK
        const loadRazorpayScript = () =>
            new Promise((resolve) => {
                if (window.Razorpay) resolve(true);
                else {

                    const script = document.createElement("script");
                    script.src = "https://checkout.razorpay.com/v1/checkout.js";
                    script.onload = () => resolve(true);
                    script.onerror = () => resolve(false);
                    document.body.appendChild(script);
                }
            });

        const res = await loadRazorpayScript();
        if (!res) {
            alert("⚠️ Razorpay SDK failed to load.");
            return;
        }

        // Step 1: Create Razorpay Order via backend
        const username = "rzp_live_RU5whSMu9rPV7s";
        const password = "khRC0vtSHCGHktyu62yekZp0";
        const basicAuth = btoa(`${username}:${password}`);

        try {
            const orderRes = await axios.post(
                "https://backend.maamaas.com/food/api/user/create-order",
                {
                    amount: amountInPaise,
                    currency: "INR",
                    vendorId: vendorIdNum,
                },
                {
                    headers: {
                        Authorization: `Basic ${basicAuth}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const { orderId } = orderRes.data;
            if (!orderId) throw new Error("Order ID not received from backend");
            console.log("✅ Razorpay Order Created:", orderId);

            // Step 2: Razorpay Checkout
            const options = {
                key: "rzp_live_RU5whSMu9rPV7s",
                amount: amountInPaise,
                currency: "INR",
                name: "Catering Service",
                description: `Payment for Order #${orderIdNum}`,
                order_id: orderId,
                handler: async function (response) {
                    console.log("✅ Razorpay Payment Success:", response);
                    const paymentId = response.razorpay_payment_id;

                    // Step 3: Save Payment Data in your backend
                    const apiUrl = `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/payment/initiate?leadId=${leadId}&vendorId=${vendorIdNum}&amount=${amount}&orderid=${orderIdNum}`;
                    try {
                        const resSave = await axios.post(apiUrl, null, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                Accept: "application/json",
                            },
                        });
                        console.log("✅ Payment recorded in backend:", resSave.data);
                    } catch (err) {
                        console.error("❌ Error recording payment:", err);
                        alert("⚠️ Payment succeeded, but failed to record in system.");
                    }

                    // Step 4: Capture Payment via Razorpay API
                    try {
                        const captureRes = await axios.post(
                            "https://backend.maamaas.com/food/api/user/capture",
                            {
                                paymentId: paymentId,
                                amount: amountInPaise,
                                currency: "INR",
                                vendorId: vendorIdNum,
                            },
                            {
                                headers: { "Content-Type": "application/json" },
                            }
                        );
                        console.log("✅ Capture API response:", captureRes.data);
                        alert("✅ Payment captured successfully!");
                    } catch (captureError) {
                        console.error("❌ Payment capture failed:", captureError);
                        alert("⚠️ Payment saved but capture failed.");
                    }
                },
                prefill: {
                    name: order.name || "",
                    email: order.email || "",
                    contact: order.mobile || "",
                },
                theme: { color: "#3399cc" },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (err) {
            console.error("❌ Razorpay order creation failed:", err);
            alert("❌ Failed to create Razorpay order. Please try again later.");
        }
    };




    const downloadPDF = (order) => {
        const doc = new jsPDF();

        // ===== Header =====
        doc.setFillColor(177, 93, 198); // Purple header background
        doc.rect(0, 0, 210, 20, "F");   // Draw full-width header


        doc.setFontSize(16);
        doc.setTextColor(255, 255, 255);

        // Left: Order ID
        doc.text(`Order ID: ${order.orderId}`, 14, 14);

        // Right: Lead Price
        const pageWidth = doc.internal.pageSize.getWidth();
        const rightMargin = 14;
        const totalText = ` Price: ${order.leadPrice || 0}`;

        // Use slightly lower Y (14) to fit inside header
        doc.text(totalText, pageWidth - rightMargin, 14, { align: "right" });



        // ===== Lead Price =====
        let y = 30;
        if (order.paymentAmount) {
            doc.setFontSize(12);
            doc.setTextColor(0, 0, 128);
            doc.text(`Including Lead Price: ₹${order.paymentAmount}`, 14, y);
            y += 10;
        }

        // ===== Customer & Order Details =====
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        const leftStart = 14;
        const rightStart = 110;

        // Left column
        doc.text(`Date: ${new Date(order.orderDateAndTime || order.createdAt).toLocaleDateString("en-IN")}`, leftStart, y + 10);
        doc.text(`Plates: ${order.numberOfPlates || 0}`, leftStart, y + 16);
        doc.text(`Order Type: ${order.orderType || "Booking"}`, leftStart, y + 22);

        // Right column
        doc.text(`Name: ${order.name || "N/A"}`, rightStart, y + 10);
        doc.text(`Mobile: ${order.mobile || "N/A"}`, rightStart, y + 16);
        doc.text(`Email: ${order.email || "N/A"}`, rightStart, y + 22);
        doc.text(`Location: ${order.clientLocation || "N/A"}`, rightStart, y + 28);

        // ===== Items Table =====
        const tableColumn = ["S.No", "Item", "Veg Plates", "Non-Veg Plates", "Mixed Plates"];
        const tableRows = [];

        order.items?.forEach((itemName, index) => {
            const vegQty = order.cartItems?.find(c => c.dishName === "Veg Plates")?.quantity || 0;
            const nonVegQty = order.cartItems?.find(c => c.dishName === "Non-Veg Plates")?.quantity || 0;
            const mixedQty = order.cartItems?.find(c => c.dishName === "Mixed Plates")?.quantity || 0;

            tableRows.push([index + 1, itemName, vegQty, nonVegQty, mixedQty]);
        });

        autoTable(doc, {
            startY: y + 40,
            head: [tableColumn],
            body: tableRows,
            theme: "grid",
            headStyles: {
                fillColor: [177, 92, 214],
                textColor: [255, 255, 255],
                halign: "center",
            },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            styles: {
                fontSize: 10,
                halign: "center",
                cellPadding: 4,
            },
            columnStyles: {
                1: { halign: "left" }, // Item name left-aligned
            },
        });

        // ===== Footer =====
        const finalY = doc.lastAutoTable.finalY + 15;
        doc.setFontSize(11);
        doc.setTextColor(100);
        doc.text("Thank you for choosing Maamaa's House Catering!", 14, finalY);

        // ===== Save PDF =====
        doc.save(`Order_${order.orderId}.pdf`);
    };


    const [orders, setOrders] = useState([]);

    // Fetch vendor leads API
    useEffect(() => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        const fetchVendorLeads = async () => {
            try {
                showLoader();
                const res = await fetch(
                    `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/${vendorId}`,
                    {
                        method: "GET",
                        headers: {
                            Accept: "*/*",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                const result = await res.json();

                // ✅ Combine fullLeads + maskedLeads
                const allLeads = [...(result.data.fullLeads || []), ...(result.data.maskedLeads || [])];

                const vendorOrders = allLeads.map((lead) => ({
                    orderId: lead.id,
                    name: lead.fullName,
                    mobile: lead.phoneNumber,
                    email: lead.email,
                    orderDateAndTime: lead.createdAt,
                    numberOfPlates:
                        (lead.vegPlates || 0) +
                        (lead.nonVegPlates || 0) +
                        (lead.mixedPlates || 0),
                    orderType: lead.eventType,
                    clientLocation: `${lead.city}, ${lead.state || "N/A"}`,
                    cartItems: [
                        { dishName: "Veg Plates", quantity: lead.vegPlates },
                        { dishName: "Non-Veg Plates", quantity: lead.nonVegPlates },
                        { dishName: "Mixed Plates", quantity: lead.mixedPlates },
                    ],
                    service: lead.accessMessage === "Payment required for full details" ? "Pay Now" : null,
                    leadPrice: lead.leadPrice,
                    items: lead.items,
                    masked: lead.masked,
                    accessible: lead.accessible,
                    accessMessage: lead.accessMessage, // 🔹 store access message
                }));

                setOrders(vendorOrders);
            } catch (err) {
                console.error("Error fetching vendor leads:", err);
            } finally {
                hideLoader();
            }
        };

        fetchVendorLeads();
    }, []);



    const orderStages = ["Order Placed", "Order Completed"];

    const styles = {
        card: {
            border: '1px solid #ccc',
            padding: '16px',
            margin: '16px',
            borderRadius: '10px',
            background: "linear-gradient(to right, #f46b45, #eea849)"
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '10px'
        },
        orderId: { margin: 0, fontWeight: "bold" },
        detailsRow: { display: 'flex', gap: '20px', fontSize: '14px', fontWeight: "bold" },
        date: { fontSize: '18px', color: '#000', fontWeight: "bold" },
        pickupBtn: {
            background: '#28a745',
            color: '#fff',
            border: 'none',
            padding: '6px 12px',
            cursor: 'pointer',
            borderRadius: '5px',
            fontWeight: "bold"
        },
        tracker: {
            marginTop: '10px',
            display: 'flex',
            alignItems: 'center',
            fontWeight: "bold"
        },
        statusBox: {
            background: '#eee',
            padding: '8px 12px',
            borderRadius: '5px',
            transition: "0.3s",
            textTransform: "uppercase"
        },
        arrow: { margin: '0 5px' },
        dropdownBtn: { background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' },
    };

    return (
        <div style={{ height: "500px", overflow: "auto", scrollbarWidth: "none" }} >
            <div >
                <div>
                    {[...orders].reverse().map((order) => {
                        const orderItems = order.cartItems || [];
                        const orderId = order.orderId;

                        // 🔹 Determine if we should show details
                        const canViewDetails =
                            paymentSuccessData[orderId] || order.accessMessage === "Full access - Payment verified";

                        return (
                            <div key={orderId} style={styles.card}>
                                {/* ===== Header ===== */}
                                <div style={styles.header}>
                                    <div>
                                        <h3 style={styles.orderId}>Order ID: {orderId}</h3>
                                    </div>
                                    <p style={{ fontWeight: "bold", fontSize: "16px" }}>
                                        Lead Price: <span>₹</span>
                                        {order.leadPrice}
                                    </p>

                                    {/* Show Pay Now button only if payment required and not done */}
                                    {order.service && !paymentSuccessData[orderId] && (
                                        <button
                                            style={styles.pickupBtn}
                                            onClick={() => handlePayment(order)}
                                        >
                                            {order.service}
                                        </button>
                                    )}

                                    <button
                                        style={styles.dropdownBtn}
                                        onClick={() =>
                                            setShowDetails((prev) => ({
                                                ...prev,
                                                [orderId]: !prev[orderId],
                                            }))
                                        }
                                    >
                                        {showDetails[orderId] ? "▲" : "▼"}
                                    </button>
                                </div>

                                {/* ===== Show user details only if access allowed ===== */}
                                {canViewDetails && (
                                    <div
                                        style={{
                                            marginTop: "0px",
                                            background: "linear-gradient(to right, rgb(244 107 68), rgb(238, 168, 73))",
                                            padding: "15px",
                                            borderRadius: "5px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            flexWrap: "wrap",
                                            color: "#000",
                                            fontSize: "16px",
                                            gap: "40px",
                                            marginLeft: "30px",
                                        }}
                                    >
                                        {/* Left Column */}
                                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                            <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                                                <span style={{ minWidth: "120px" }}><strong>Date</strong></span>
                                                <span style={{ minWidth: "20px" }}>:</span>
                                                <span style={{ color: "black" }}>
                                                    {new Date(order.orderDateAndTime).toLocaleDateString("en-IN")}
                                                </span>
                                            </div>

                                            <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                                                <span style={{ minWidth: "120px" }}><strong>Plates</strong></span>
                                                <span style={{ minWidth: "20px" }}>:</span>
                                                <span>{order.numberOfPlates || 0}</span>
                                            </div>

                                            <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                                                <span style={{ minWidth: "120px" }}><strong>Order Type</strong></span>
                                                <span style={{ minWidth: "20px" }}>:</span>
                                                <span>{order.orderType || "Booking"}</span>
                                            </div>
                                        </div>

                                        {/* Right Column */}
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "6px",
                                                marginRight: "40px",
                                                alignItems: "flex-start",
                                            }}
                                        >
                                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <span style={{ minWidth: "120px", fontWeight: "bold" }}>Name</span>
                                                <span style={{ minWidth: "20px" }}>:</span>
                                                <span>{paymentSuccessData[orderId]?.name || order.name}</span>
                                            </div>

                                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <span style={{ minWidth: "120px", fontWeight: "bold" }}>Mobile</span>
                                                <span style={{ minWidth: "20px" }}>:</span>
                                                <span>{paymentSuccessData[orderId]?.mobile || order.mobile}</span>
                                            </div>

                                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <span style={{ minWidth: "120px", fontWeight: "bold" }}>Email</span>
                                                <span style={{ minWidth: "20px" }}>:</span>
                                                <span>{paymentSuccessData[orderId]?.email || order.email}</span>
                                            </div>

                                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <span style={{ minWidth: "120px", fontWeight: "bold" }}>Location</span>
                                                <span style={{ minWidth: "20px" }}>:</span>
                                                <span>{order.clientLocation || "N/A"}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* ===== Order Items Table (expandable) ===== */}
                                {showDetails[orderId] && (
                                    <table
                                        style={{
                                            width: "100%",
                                            borderCollapse: "collapse",
                                            marginTop: "1rem",
                                        }}
                                        className="leads-data-table"
                                    >
                                        <thead>
                                            <tr style={{ backgroundColor: "#b15cd6", textAlign: "center" }}>
                                                <th style={{ padding: "8px", border: "1px solid #ddd" }}>S.No</th>
                                                <th style={{ padding: "8px", border: "1px solid #ddd" }}>Items</th>
                                                <th style={{ padding: "8px", border: "1px solid #ddd" }}>Veg Plates</th>
                                                <th style={{ padding: "8px", border: "1px solid #ddd" }}>Non-Veg Plates</th>
                                                <th style={{ padding: "8px", border: "1px solid #ddd" }}>Mixed Plates</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {order.items?.map((itemName, index) => (
                                                <tr
                                                    key={index}
                                                    style={{
                                                        borderBottom: "1px solid #eee",
                                                        fontWeight: "bold",
                                                        backgroundColor: "#d4edda",
                                                    }}
                                                >
                                                    <td style={{ padding: "8px", border: "1px solid #ddd" }}>{index + 1}</td>
                                                    <td style={{ padding: "8px", border: "1px solid #ddd" }}>{itemName}</td>
                                                    {/* Show plates from cartItems */}
                                                    <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                        {order.cartItems?.find(c => c.dishName === "Veg Plates")?.quantity || 0}
                                                    </td>
                                                    <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                        {order.cartItems?.find(c => c.dishName === "Non-Veg Plates")?.quantity || 0}
                                                    </td>
                                                    <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                        {order.cartItems?.find(c => c.dishName === "Mixed Plates")?.quantity || 0}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}


                                {/* ===== Download PDF Button (only after payment or full access) ===== */}
                                {canViewDetails && (
                                    <div style={{ textAlign: "center", justifyContent: "center" }}>
                                        <button
                                            style={{
                                                marginTop: "15px",
                                                justifyContent: "center",
                                                padding: "8px 12px",
                                                backgroundColor: "#4caf50",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                                textAlign: "center",
                                            }}
                                            onClick={() => downloadPDF(order)}
                                        >
                                            Download PDF
                                        </button>
                                    </div>
                                )}
                            </div>
                        );
                    })}


                </div>
            </div>
        </div >
    );
};

export default LeadsOrders;
